export default __webpack_public_path__ + "static/media/ZASortIcon.652bae69.svg";